import { Component, OnInit } from '@angular/core';
import { State } from 'src/app/utilities/state';
import { SolUrls } from 'src/app/services/sol-urls';
import { SideMenuService } from './side-menu.service';
import { I18nService } from 'src/app/services/i18n.service';
import { SolApiService } from 'src/app/services/sol-api.service';
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnInit {
  state: State = new State();
  urls: SolUrls = new SolUrls();
  currentTab = '';
  fraud = false;
  pageData;
  mainSlug;
  curSlug = ''
  sideMenuItems = [];
  checkMenuRes = false;
  fraudMenuItems = [];
  childMenuItems = { id: 0, items: [] };
  menuLevel = { MainId: 0, level: 0 };
  currentLang: String;
  constructor(private sideMenuService: SideMenuService,
    private apiService: SolApiService,
    private i18nService: I18nService) {
    this.i18nService.getLang().subscribe((lng) => {
      if (lng == null) {
        lng = 'ar';
      }
      this.currentLang = lng;
    })
  }

  ngOnInit() {

    this.curSlug = localStorage.getItem('currentSlug');
    this.sideMenuService.data.subscribe((data: any) => {
      this.pageData = data;
      if (data) {
        this.mainSlug = data.slug
      }
      this.getMenuItems(this.pageData);
    });
    this.sideMenuService.menuItems.subscribe(items => {

      this.curSlug = localStorage.getItem('currentSlug');
      if (this.curSlug === 'fraudTypes') {
        this.fraudMenuItems = items;
        this.sideMenuItems = [];
      } else {
        this.sideMenuItems = items;
        this.fraudMenuItems = [];
      }

    });

    this.sideMenuService.currentActive.subscribe(tab => {

      this.childMenuItems.items = [];
      this.changeTab(tab);
    });
    this.sideMenuService.fraud.subscribe(tab => {
      this.fraud = tab;
    });
  }

  getMenuItems(page) {

    if (page) {
      if (page.id) {
        // && !page.slug && !slug
        this.apiService
          .get(false, 'getMenu', `id=${page.id}`)
          .subscribe(response => {

            if (response.data.pages.child_id == null) {
              // if(page.slug || slug){
              //   this.sharedMethod(page);
              // } else {
              this.sideMenuItems = response.data.pages.pages;

              this.fraudMenuItems = [];
              this.menuLevel = { MainId: page.id, level: 0 };
              // }

            } else {
              this.checkForMenuLevels(page.id);
            }

          });
      }
      else {
        this.sharedMethod(page);
      }

    }
    else {
      this.sharedMethod(page);
    }
  }

  sharedMethod(page) {
    localStorage.setItem('currentSlug', this.mainSlug);
    this.sideMenuService.menuItems.subscribe(items => {
      const curSlag = localStorage.getItem('currentSlug');
      if (curSlag === 'fraudTypes') {
        this.fraudMenuItems = items;
        this.sideMenuItems = [];
      } else {
        this.sideMenuItems = items;
        this.fraudMenuItems = [];
      }

    });

  }

  changeTab(itemId) {
    this.currentTab = '-1'
    this.childMenuItems.id = itemId;
    this.childMenuItems.items = [];
    this.currentTab = itemId;
    this.apiService
      .get(false, 'getMenu', `id=${itemId}`)
      .subscribe(response => {
        if (response.data.pages) {
          this.childMenuItems.items = response.data.pages.pages;
        }
      });
    // document.getElementById("content").scrollIntoView();
  }

  checkForMenuLevels(itemId) {
    this.currentTab = itemId;
    this.apiService.get(false, 'getMenu', `id=${itemId}`).subscribe(response => {
      let child = response.data.pages;
      if (child) {
        if (this.menuLevel.MainId) {
          child.child_id == this.menuLevel.MainId ? this.menuLevel.level = 1 : this.menuLevel.level = 2;
          if (child.pages.length > 0) {
            child.pages.forEach(child_page => {
              this.checkForMenu(child_page.id, 'pages', child);
            });
          } else {
            if (this.menuLevel.level == 1) {
              this.getMenuItems({ id: child.child_id });
            } else {
              // this.changeTab(child.child_id);
              // this.apiService.get(false, 'getMenu', `id=${child.child_id}`).subscribe(response => {
              //   let parent = response.data.pages;
              //   if(child.pages.length > 0){
              //     this.sideMenuItems = parent.pages

              //   } else {
              //     // this.sideMenuItems = parent
              //     // this.changeTab(child.child_id);
              //   }

              // });


            }
          }
        } else {
          if (child.child_id) {
            this.checkForMenu(child.child_id, 'mainLevel', itemId);
          }
        }
      }
    });
  }

  checkForMenu(id, checkType, current?) {
    this.apiService.get(false, 'getMenu', `id=${id}`).subscribe(res => {
      let child = res.data.pages;
      let result;
      switch (checkType) {
        case 'pages':
          if (child.pages.length > 0) {
            this.sideMenuItems = current.pages;
            this.childMenuItems.items = [];
            this.fraudMenuItems = [];
          } else {
            // this.changeTab(current.id);
          }
          break;
        case 'mainLevel':
          child.child_id ? result = false : result = true;
          if (result) {
            this.menuLevel.MainId = child.id;
          } else {
            this.menuLevel.MainId = child.child_id;
          }
          this.apiService.get(false, 'getMenu', `id=${this.menuLevel.MainId}`).subscribe(par => {
            let parent = par.data.pages;
            this.sideMenuItems = parent.pages;
            this.checkForMenuLevels(current);
          });

          break;
        default:
          break;
      }
    })
  }

  getImage(image: string) {
    return this.urls.getStorageUrl() + '/' + JSON.parse(image)[0].download_link;
  }
}
